import { Flex, FormControl } from '@chakra-ui/react'
import { useState } from 'react'
import { MdClose } from 'react-icons/md'
import Modal from 'react-modal'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { TextAreaCmp } from '../../../../../components/TextareaCmp'
import { WhiteModal } from './styles'

interface iModalProps {
  isOpen: boolean
  onCreate: (text: string) => void
  onClose: () => void
}

export const ModalIA: React.FC<iModalProps> = ({ isOpen, onClose, onCreate }) => {
  const [TextoAjuda, setTextoAjuda] = useState('')

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content-default"
    >
      <WhiteModal>
        <FormControl as={Flex} flexDir="column" gap="1rem">
          <Flex justifyContent={'space-between'}>
            <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: 'var(--Azul)' }}>
              Gerar informações sobre o cargo com IA
            </h3>
            <Flex color='var(--Red)' _hover={{ color: 'var(--Red-hover)' }}>
              <MdClose cursor={'pointer'} size={18} onClick={onClose}/>
            </Flex>
          </Flex>

          <Flex flexDir={'column'} gap="1rem">
            <TextAreaCmp
              label='Insira um texto de apoio aqui para a IA'
              value={TextoAjuda}
              height={'10rem'}
              OnChange={setTextoAjuda}
            />
          </Flex>
        </FormControl>

        <Flex justifyContent="end" gap=".375rem" mt="1rem">
          <ButtonCmp VarColor="c6" onClick={onClose}>Cancelar</ButtonCmp>
          <ButtonCmp VarColor="Green2" onClick={() => onCreate(TextoAjuda)}>Confirmar</ButtonCmp>
        </Flex>
      </WhiteModal>
    </Modal>
  )
}
